import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../data/site";

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">Kind words</p>
        <h2 className="font-serif font-light text-5xl md:text-6xl text-[#1A362D] tracking-tight max-w-2xl leading-[1.05]">
          Loved by busy households.
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <div className="h-full p-8 rounded-2xl border border-[#D5D1C8] bg-[#EAE6DF] flex flex-col">
              <span className="font-serif text-6xl text-[#C26D5C] leading-none">&ldquo;</span>
              <p className="font-serif text-2xl text-[#1A362D] leading-snug -mt-4">{t.quote}</p>
              <div className="mt-auto pt-8">
                <p className="font-semibold text-[#1A362D]">{t.name}</p>
                <p className="text-sm text-[#7B8A83]">{t.role}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
